import { api } from '@/lib/api';

export interface Meta { page: number; per_page: number; total: number; last_page: number }
export interface Envelope<T = any> { success: boolean; message?: string; data: T; meta?: Meta }

export interface CallOpts {
  params?: Record<string, unknown>;
  body?: unknown;
  pin?: string;
  idemKey?: string;
}

/** Typed envelope call used by the bursar/desk pages. Adds X-Pin / Idempotency-Key when supplied. */
export async function call<T = any>(method: 'get' | 'post' | 'put' | 'delete', url: string, o: CallOpts = {}): Promise<Envelope<T>> {
  const headers: Record<string, string> = {};
  if (o.pin) headers['X-Pin'] = o.pin;
  if (o.idemKey) headers['Idempotency-Key'] = o.idemKey;
  const res = await api.request({ method, url, params: o.params, data: o.body, headers });
  return res.data as Envelope<T>;
}

export const dget = <T = any>(url: string, params?: Record<string, unknown>, pin?: string) => call<T>('get', url, { params, pin });

// Endpoints missing from the generated wrappers.
export const putSiblingRule = (body: unknown) => call('put', '/school/discounts/sibling-rule', { body });
export const approveDiscount = (id: number | string) => call('post', `/school/discounts/${id}/approve`);
export const approveBankAccount = (id: number | string) => call('post', `/school/bank-accounts/${id}/approve`);
export const provisionPaymentAccount = () => call('post', '/school/payment-accounts/provision');
export const assignPayment = (id: number | string, body: unknown, idemKey: string) => call('post', `/school/payments/${id}/assign`, { body, idemKey });
export const duplicateReview = (id: number | string, body: unknown, idemKey: string) => call('post', `/school/payments/${id}/duplicate-review`, { body, idemKey });
export const postManualClockin = (body: unknown) => call('post', '/school/clockin/manual', { body });
export const resultConfig = (kind: 'composite-subjects' | 'result-templates' | 'result-signatories') => ({
  list: () => call('get', `/school/${kind}`),
  create: (body: unknown) => call('post', `/school/${kind}`, { body }),
  update: (id: number | string, body: unknown) => call('put', `/school/${kind}/${id}`, { body }),
  remove: (id: number | string) => call('delete', `/school/${kind}/${id}`),
});
export const exportResults = (body: unknown) => call('post', '/school/results/export', { body });
